import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Heart } from "lucide-react";

interface BLEConnectionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export const BLEConnectionDialog = ({
  open,
  onOpenChange,
  onConfirm,
}: BLEConnectionDialogProps) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-w-[90%] sm:max-w-md">
        <AlertDialogHeader>
          <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 rounded-full bg-primary/10">
            <Heart className="w-6 h-6 text-primary" />
          </div>
          <AlertDialogTitle className="text-center">
            Conectar Monitor Cardíaco
          </AlertDialogTitle>
          <AlertDialogDescription className="text-center">
            Conecte um monitor de frequência cardíaca para acompanhar sua performance em tempo real.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="space-y-3">
          <div className="text-sm space-y-2 text-left bg-muted/50 p-3 rounded-lg">
            <p className="font-medium text-foreground">Benefícios:</p>
            <ul className="space-y-1 ml-4 list-disc text-muted-foreground">
              <li>Monitoramento BPM em tempo real</li>
              <li>Identificação de zonas de treino</li>
              <li>Música adaptativa ao ritmo cardíaco</li>
              <li>Análise detalhada pós-corrida</li>
            </ul>
          </div>
          <p className="text-xs text-muted-foreground text-center">
            Seus dados de frequência cardíaca são privados e seguros. Compatível com dispositivos Bluetooth como Garmin, Polar, Apple Watch e outros.
          </p>
        </div>
        <AlertDialogFooter className="flex-col sm:flex-row gap-2 mt-4">
          <AlertDialogCancel>Não Agora</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className="bg-primary">
            Parear Dispositivo
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
